import type { BillingPayment } from '@practium/features/api';
import type { BillingPaymentRow } from '../types/billing.types';

const TIME_ZONE = 'America/Sao_Paulo';
const EMPTY_VALUE = '—';

const PAYMENT_METHOD_LABELS: Record<string, string> = {
	credit_card: 'Cartão',
	pix: 'PIX',
	boleto: 'Boleto',
};

export const mapPaymentToRow = (payment: BillingPayment): BillingPaymentRow => {
	const plan = typeof payment.plan === 'object' ? payment.plan : null;
	const user = typeof payment.user === 'object' ? payment.user : null;
	const createdAt = new Date(payment.createdAt);

	return {
		_id: payment._id,
		planName: plan?.name ?? EMPTY_VALUE,
		chargeId: payment.chargeId,
		shortChargeId: payment.chargeId ? `#${payment.chargeId.slice(-6).toUpperCase()}` : EMPTY_VALUE,
		clientName: payment.fullName || user?.name || EMPTY_VALUE,
		city: user?.address?.city || EMPTY_VALUE,
		gateway: payment.gatewayName ?? EMPTY_VALUE,
		method: PAYMENT_METHOD_LABELS[payment.paymentMethod ?? ''] ?? (payment.paymentMethod || EMPTY_VALUE),
		date: createdAt.toLocaleDateString('pt-BR', { timeZone: TIME_ZONE }),
		time: createdAt.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', timeZone: TIME_ZONE }),
		amount: payment.amount,
		chargeStatus: payment.chargeStatus,
	};
};
